var mapHorizontalContentAlignment = function mapHorizontalContentAlignment(horizontalContentAlignment) {
  return horizontalContentAlignment === 'start' ? 'start' : 'center';
};
var mapTextAlign = function mapTextAlign(horizontalContentAlignment) {
  return horizontalContentAlignment === 'start' ? 'start' : 'center';
};
var getTitleProps = function getTitleProps(horizontalContentAlignment) {
  return {
    variant: 'heading-l',
    textColor: 'base.default',
    textAlign: mapTextAlign(horizontalContentAlignment)
  };
};
var getSubtitleProps = function getSubtitleProps(horizontalContentAlignment) {
  return {
    variant: 'caption-default',
    textColor: 'base.subtle',
    pt: '4',
    textAlign: mapTextAlign(horizontalContentAlignment)
  };
};
var getHeaderContentProps = function getHeaderContentProps(horizontalContentAlignment) {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: mapHorizontalContentAlignment(horizontalContentAlignment),
    m: horizontalContentAlignment === 'center' ? 'auto' : undefined
  };
};

export { getHeaderContentProps, getSubtitleProps, getTitleProps };
//# sourceMappingURL=HeaderContent.mappers.js.map
